<template>
  <div v-if="attachments" class="mb-3">
    <div v-for="attachment in attachments" :key="attachment.idCustomerMessageAttachment" class="mb-2 last:mb-0">
      <UploadAttachmentEmbed
        v-if="attachment.isTypeUpload"
        :attachment="attachment"
      />

      <ReservationAttachmentEmbed
        v-if="attachment.isTypeReservation"
        :attachment="attachment"
      />

      <OrderAttachmentEmbed
        v-if="attachment.isTypeOrder"
        :attachment="attachment"
      />

      <CustomerFormAttachmentEmbed
        v-if="attachment.isTypeCustomerForm"
        :attachment="attachment"
      />

      <CampaignAttachmentEmbed
        v-if="attachment.isTypeCampaign"
        :attachment="attachment"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import UploadAttachmentEmbed from '../types/upload/Embed.vue'
import ReservationAttachmentEmbed from '../types/reservation/Embed.vue'
import OrderAttachmentEmbed from '../types/order/Embed.vue'
import CustomerFormAttachmentEmbed from '../types/customerForm/Embed.vue'
import CampaignAttachmentEmbed from '../types/campaign/Embed.vue'

interface Props {
  attachments: any[]
}

defineProps<Props>()
</script>
